import layout from '@/layout'

export default {
  path: '/famous',
  component: layout,
  redirect: '/famous/index',
  name: 'famousIndex',
  meta: {
    title: 'famous',
    icon: 'famous'
  },
  children: [
    {
      path: '/famous/index',
      name: 'famousIndex',
      component: () => import('@/views/famous/index'),
      meta: {
        title: 'famousIndex',
        icon: 'famous'
      }
    }
  ]
}
